import Link from 'next/link';
import { IProduct } from '@monofront/types';
import ProductReviewsSumup from '../ProductReviewsSumup';
import ProductFormat from '../ProductFormat';
import ProductOrigin from '../ProductOrigin';
import useI18n from '@hooks/i18n/useI18n';
import ProductPriceActions from '../ProductPriceActions';
import ProductGoodToKnow from '../ProductGoodToKnow';
import ProductComposition from '../ProductComposition';
import ProductDestock from '../ProductDestock';
import { getIsFresh } from '@monofront/business/utils';
import ProductHero from '../ProductHero';
import { useMediaQuery } from '@monofront/business/hooks';
import ButtonAddToWishlist from '@components/ButtonAddToWishlist/ButtonAddToWishlistDEPRECATED';
import ProductReinsurance from '../ProductReinsurance';
import ProductCharacteristics from '../ProductCharacteristics';
import ProductScores from '../ProductScores';

interface IProductAsideProps {
  product: IProduct;
  isNavigationDisabled?: boolean;
}

const ProductAside: React.FC<IProductAsideProps> = ({
  product,
  isNavigationDisabled = false,
}) => {
  const { isFrenchMarket, isGermanMarket } = useI18n();
  const isMobile = useMediaQuery(800);
  const { reviews_stats } = product.meta;
  const isFresh = getIsFresh(product.tags);
  const vendorLink = product.vendor_collection
    ? `/collections/${product.vendor_collection.handle}`
    : `/collections/all?vendor=${product.vendor}`;

  return (
    <section
      className={`tw-mt-5 desktop:tw-order-2 desktop:tw-mt-7
      desktop:tw-self-start min-[801px]:tw-w-[50vw]
      min-[960px]:tw-w-[462px] min-[960px]:tw-shrink-0
    `}
    >
      {isNavigationDisabled ? (
        <p className="tw-lf-link-md tw-lf-link-no-underline tw-mr-9 desktop:tw-mr-0">
          {product.vendor}
        </p>
      ) : (
        <Link
          href={vendorLink}
          className="tw-lf-link-md tw-lf-link-no-underline tw-mr-9 desktop:tw-mr-0"
        >
          {product.vendor}
        </Link>
      )}
      <h1
        data-sku={product.sku}
        className="tw-lf-title-md tw-mr-9 tw-mt-2 desktop:tw-mr-0"
      >
        {product.title}
      </h1>

      {isMobile && (
        <ButtonAddToWishlist
          variantId={product.objectID}
          name={product.title}
          sku={product.sku}
          price={product.price}
          comparedPrice={product.compare_at_price}
          image={product.image}
          product={product}
          UNSAFE_className="tw-absolute tw-right-0 tw-top-1"
        />
      )}

      {reviews_stats && (
        <ProductReviewsSumup reviewsStats={reviews_stats} withAnchor />
      )}
      <ProductFormat product={product} />

      {isMobile && <ProductHero product={product} UNSAFE_className="tw-mt-4" />}

      <ProductDestock product={product} />
      <ProductComposition product={product} />
      {isFrenchMarket && isFresh && <ProductOrigin product={product} />}
      <ProductGoodToKnow product={product} />

      {isFrenchMarket && !isFresh && <ProductOrigin product={product} />}

      <ProductPriceActions
        id="main-price-actions"
        product={product}
        withWishlistButton
      />

      <ProductReinsurance product={product} />

      <ProductCharacteristics product={product} />
      <ProductScores product={product} />

      {isGermanMarket && <ProductOrigin product={product} />}
    </section>
  );
};

export default ProductAside;
